
export default defineNuxtPlugin((nuxtApp) => {
  const baiduId = nuxtApp.$config.public.baiduId
  // 只在生产环境加载
  if (process.env.NODE_ENV === 'production') {
    // 添加百度统计脚本
    const script = document.createElement('script')
    script.src = `https://hm.baidu.com/hm.js?${baiduId}`
    script.async = true
    document.head.appendChild(script)
    
    // 监听路由变化
    nuxtApp.hook('page:finish', () => {
      // 确保百度统计的全局对象存在
      if (typeof window._hmt !== 'undefined') {
        
        window._hmt.push(['_trackPageview', window.location.pathname])
      }
    })
  }
});